import {useRef} from 'react'
import {Field, Form} from 'react-final-form'

import {Action} from 'src/components/Action'
import {Box, Flex} from 'src/components/Box'
import * as styles from 'src/styles'
import {SearchIcon} from 'src/components/icons'
import {gradients} from 'src/styles'
import * as breakpoints from 'src/styles/mediaQuery'

const ScholarshipSearch = ({
  setSearchQuery,
}: {
  setSearchQuery: ({
    query,
    searchQuery,
  }: {
    query: string
    searchQuery: string
  }) => void
  allTags: string[]
}) => {
  const onSubmit = (values: {query: string; searchQuery: string}) => {
    setSearchQuery(values)
  }

  const formRef = useRef<HTMLFormElement | null>(null)

  return (
    <Box
      width={{lg: '100%', default: '100vw'}}
      ml={{default: -20, lg: '0px'}}
      background={gradients.pinkYellow}
      borderRadius={{lg: '20px', default: '0'}}
    >
      <Form onSubmit={onSubmit}>
        {({handleSubmit}) => (
          <form
            ref={formRef}
            onSubmit={handleSubmit}
            css={{flex: 1, padding: '30px'}}
          >
            <Flex
              height={{md: '2.5rem', default: '1.25rem,'}}
              alignItems="center"
            >
              <Field
                component="input"
                name="query"
                placeholder="Search by Your City, State, Identity, Area of Study & More"
                autoComplete="off"
                type="text"
                css={(theme) => ({
                  flex: 1,
                  height: '100%',
                  padding: theme.space[1],
                  borderColor: theme.colors.white,
                  borderRadius: 10,
                  ...styles.typography.body,
                  boxShadow: '0px 4px 30px 0px rgba(20, 36, 44, 0.13)',
                })}
              />
              <Action
                aria-label="Search content"
                type="submit"
                css={(theme) => ({
                  background: theme.colors.grey2,
                  padding: `${theme.space[1]} ${theme.space[2]}`,
                  minWidth: 'initial',
                  borderTopRightRadius: 10,
                  borderBottomRightRadius: 10,
                  marginLeft: '-10px',
                  boxShadow: '0px 4px 30px 0px rgba(20, 36, 44, 0.13)',
                  display: 'none',
                  [breakpoints.medium]: {
                    display: 'block',
                  },
                })}
              >
                <SearchIcon height="2.5rem" aria-label="Search" />
              </Action>
              <Action
                aria-label="Search content"
                type="submit"
                css={(theme) => ({
                  padding: `${theme.space[1]} ${theme.space[2]}`,
                  minWidth: 'initial',
                  borderTopRightRadius: 10,
                  borderBottomRightRadius: 10,
                  marginLeft: '-50px',
                  display: 'block',
                  pointerEvents: 'none',
                  [breakpoints.medium]: {
                    display: 'none',
                  },
                })}
              >
                <SearchIcon aria-label="Search" />
              </Action>
            </Flex>
          </form>
        )}
      </Form>
    </Box>
  )
}

export default ScholarshipSearch
